import classnames from 'classnames';
import { Checkbox } from '@doda/io-react/common';
import React, { ComponentProps } from 'react';
import { addComma } from '@doda/common/src/utils/convNumberUtil';
import styles from './index.module.scss';

/**
 * 検索サイドバー・チェックボックス Props インターフェース
 */
interface Props {
  /** タイトル */
  title: string;
  /** チェックボックスの値 */
  value: ComponentProps<typeof Checkbox>['value'];
  /** (オプション) 求人数カウント */
  count?: number;
  /** チェックボックスの変更イベントハンドラー */
  onChange: ComponentProps<typeof Checkbox>['onChange'];
  /** チェックボックスのチェック状態 */
  isChecked: boolean;
  /** (オプション) チェックボックスサイズ */
  size?: 'L';
}

/**
 * 検索サイドバー・チェックボックス
 *
 * @param {Props} props - 検索チェックボックスのプロパティ
 * @returns {JSX.Element} Reactコンポーネント
 */
export const SearchCheckboxItem: React.FC<Props> = ({
  title,
  value,
  count,
  onChange,
  isChecked,
  size,
}) => {
  return (
    <div className={styles.searchCondition__checkbox__wrapper}>
      <Checkbox
        onChange={onChange}
        value={value}
        label={
          <div>
            <span
              className={classnames(styles.checkboxItem__title, {
                [styles['checkboxItemS__title--checked']]: isChecked,
                [styles['-large']]: size === 'L',
              })}
            >
              {title}
            </span>
            {count === undefined ? null : (
              <span className={styles.checkboxItem__numberOfJobs}>
                ({addComma(count)})
              </span>
            )}
          </div>
        }
        checked={isChecked ?? false}
      />
    </div>
  );
};
